import { WprBaseViewInfo } from '../../wpr-framework/view/WprBaseViewInfo';
import { WprModel } from '../../wpr-framework/view/deco/WprModel';
import { ErrorInfo } from '../../models/ErrorInfo';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { VIEW_DEFINE_JSON, ROOT_TITLE } from '../../common/viewDefine';
import { postUtagView } from '../../../public/utag';

/**
 * エラー表示ビュー情報
 */
export class ErrorComponentView extends WprBaseViewInfo {
	// モデル -------------------------------------------------------------------
	@WprDI_GlobalScopeModel('product')
	private m_ProductCode: string 		= null;
	@WprDI_GlobalScopeModel('ErrorInfo')
	@WprModel('ErrorInfo')
	private m_ErrorInfo: ErrorInfo = null;		// エラーメッセージ
	@WprDI_GlobalScopeModel('location')
	private m_Location: string = null;
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('error');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		this.addConfig('errorMsg', 'エラーメッセージ', 'ErrorInfo', { bindName: 'message' });
	}

	/**
     * アクション登録
     */
	public onRegisterAction(): void {
		this.addAction('prev', this.onPrev);
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		document.title = VIEW_DEFINE_JSON[10].title+ROOT_TITLE;
		if (!this.m_ErrorInfo) {
			this.m_ErrorInfo = new ErrorInfo();	
			this.m_ErrorInfo.message = 'システムエラーが発生しました。恐れ入りますが、最初からやり直してください。';
			console.log('firstRedirectエラー');
		}
		this.onUtagView();
		this.setGlobalScopeModel('ErrorInfo', this.m_ErrorInfo);
		this.refreshView();
	}

	/**
	 * ドキュメントタイトル取得
	 * @returns ドキュメントタイトル
	 */
	public getDocumentTitle() : string {
		if (this.name !== '') {
			const viewDifine = VIEW_DEFINE_JSON.find((view) => {
				return (view.virtualPage === '/'+this.name);
			});
			if (viewDifine !== null) {
				return viewDifine.title+ROOT_TITLE;
			}
		}
		return null;
	}
	// --------------------------------------------------------------------------

	// アクション  ---------------------------------------------------------------
	/**
	 * 戻る処理
	 */
	public onPrev(param: any): void {
		// this.pushPath('/step1_riskfactor');
		if (this.m_Location.includes('step5_personal-information'))
			this.pushPath('/step5_personal-information');
		else
			this.pushPath('/step1_riskfactor');
	}
	// --------------------------------------------------------------------------
	
	// private メソッド  ---------------------------------------------------------------
	/**
	 * Tealium Utag View　処理
	 */
	private onUtagView(): void {
		try {
			postUtagView(VIEW_DEFINE_JSON[10], this.m_ProductCode);
		} catch (e) {
			console.log('utag_view post error');
		}
	}
	// --------------------------------------------------------------------------
}